// import { Provider } from "react-redux";
// import App from "./components/App/App";
import "./index.css";
import "modern-normalize";
// import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router-dom";
import { LanguageProvider } from "./components/LanguageProvider/LanguageProvider";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/App/App";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <LanguageProvider>
      {/* <PersistGate loading={null} persistor={persistor}> */}
      <BrowserRouter>
        <App />
      </BrowserRouter>
      {/* </PersistGate> */}
    </LanguageProvider>
  </React.StrictMode>
);

{
  /* <Provider store={perStore}>
  <PersistGate loading={null} persistor={persistor}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </PersistGate>
</Provider>; */
}
